import React from "react";
import { Button } from "@truevault/aquilo";
import { useSurvey } from "../../../../common/hooks/api/useSurvey";
import { CollectionGroupDetailsDto } from "../../../../common/service/server/dto/CollectionGroupDto";
import { usePrimaryOrganizationId } from "../../../hooks";
import { UUIDString } from "../../../../common/service/server/Types";

export const EMPLOYEE_COLLECTION_PURPOSES_SURVEY = "emp-collection-purposes";

export const collectsCommercialInfoSlug = (cg: CollectionGroupDetailsDto) =>
  `does-collect-${cg?.id}`;

export const collectsCommercialInfoSlugById = (id: UUIDString) => `does-collect-${id}`;

export function isHrPurposesComplete(
  answers: Record<string, string | undefined> | undefined,
  groupId: string | undefined,
): boolean {
  if (!answers || !groupId) {
    return false;
  }
  return Boolean(answers[collectsCommercialInfoSlugById(groupId)]);
}

type PurposesStepProps = {
  employeeGroup: CollectionGroupDetailsDto;
};

export const EmploymentGroupPurposesQuestion: React.FC<PurposesStepProps> = ({ employeeGroup }) => {
  const organizationId = usePrimaryOrganizationId();
  const qSlug = collectsCommercialInfoSlug(employeeGroup);

  const { answers, setAnswer } = useSurvey(organizationId, EMPLOYEE_COLLECTION_PURPOSES_SURVEY);
  const answer = answers[qSlug];
  const questionText = `Does your business use personal information about ${employeeGroup.name} for commercial purposes?`;

  return (
    <div className="tw-boundary">
      <div className="rounded-[8px] border border-solid border-neutral-300">
        <div className="px-[26px] py-[16px] border-l-[10px] border-primary-100 rounded-l-[8px]">
          <div className="text-[18px] leading-[20px] text-neutral-900 font-semibold">
            Commercial Purposes
          </div>
          <div className="text-[16px] leading-[24px] text-neutral-600">{questionText}</div>
          <div className="text-[14px] leading-[20px] text-neutral-500 mt-[4px]">
            Answer yes if your business actively markets to its employees, such as by adding them to
            its marketing lists.
          </div>
          <div className="flex w-full max-w-[530px] justify-between items-center gap-[12px] p-[16px] rounded-[6px] border border-solid border-neutral-300 mt-[16px]">
            <div className="min-w-0 flex-1">{employeeGroup.name}</div>
            <div className="flex shrink-0 gap-[12px]">
              <Button
                color={answer === "true" ? "primary" : "tertiary"}
                size="xs"
                onClick={() => setAnswer(qSlug, "true", questionText)}
              >
                Yes
              </Button>
              <Button
                color={answer === "false" ? "primary" : "tertiary"}
                size="xs"
                onClick={() => setAnswer(qSlug, "false", questionText)}
              >
                No
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
